import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Piskoti",
  "description": "",
  "published": "2006-12-25T00:00:00.000Z",
  "redirect_from": ["/blog/piskoti/swizec/343"],
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Torej je bozic, ali nek tak pomemben potrosniski praznik, ki je bil izmalicen do glupe nerazpoznavnosti in nikomur starejsemu od dvanajst pravzaprav vec nic ne pomeni.`}</p>
    <p>{`Odlocil sem se torej, da to storim malo drugace kot drugi in namesto nekega plozanja o bozicu in blablabla raje povem nekaj resnic o piskotih. Res je, hotel sem imati ta pogovor z opecno steno ze pred nekaj casa, ampak ga pac nisem. Piskoti so zlobna vrsta, cesarkoli pac ze so. Skoraj sem preprican, da prihajajo iz neke oddaljene galaksije in so okuzili nase mozgane z majhnimi virusi, zaradi katerih delamo vedno vec teh zlobnih bitij. Po mojih opazanjih se sirijo tako, da jih zive pojemo, kar nespremenljivo povzorci zeljo, da jih pojemo se vec. Scasoma ta zlobna zelja zavzame celo zrtev dokler ni zavzeta toliko, da zacne ustvarjati nove piskote.`}</p>
    <p>{`Ko bo preteklo dovolj casa, sem preprican, bodo piskoti zavzeli cel svet in ustvarili kolonijo, ki bo pocasi zavzela venero ali kamorkoli je ze pobegnil preostali del clovestva, scasoma ne bo vec vesolja, samo se en velik piskot.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      